import { camelToSnake, snakeToCamel } from "caseparser";

import { RequestMethod } from "@/shared/utils/RequestMethod";
import { api } from "@/app/app.api";

export const feesApi = api
  .enhanceEndpoints({ addTagTypes: ["fees-user",] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      feesUser: builder.query({
        query: ({ branchId, userId }: any) => ({
          url: `branchs/${branchId}/fees-user/${userId}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["fees-user"],
      }),
      update: builder.mutation({
        query: ({
          id,
          branchId,
          date,
        }) => ({
          url: `branchs/${branchId}/fees-user`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            id,
            date,
          }),
        }),
      }),
    }),
  });

export const {
  useFeesUserQuery,
  useUpdateMutation,
} = feesApi;
